export default "__VITE_ASSET__z6HJ1Llj__"